import React, { useState } from 'react';
import './Foot.css';

const Footer = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is HR SaaS?",
      answer: "HR SaaS is an all-in-one solution for managing human resource operations such as hiring, payroll, and employee management."
    },
    {
      question: "How secure is my data?",
      answer: "Your data is protected with industry-standard encryption and security measures to ensure privacy and safety."
    },
    {
      question: "Can I try before buying?",
      answer: "Yes, you can start with our free demo to explore the platform before making any commitments."
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact">
          <h3>Contact Us</h3>
          {/* <p>Email: support@hrsaas.com</p> */}
          <p>Phone: +260 971873484</p>
        </div>
        
        <div className="faq">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => toggleAccordion(index)}>
                <h3>{faq.question}</h3>
                <span>{activeIndex === index ? '-' : '+'}</span>
              </div>
              {activeIndex === index && <p className="faq-answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} HR SaaS. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

// import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// import "./Foot.css"

// const Footer = () => {
//   return (
//     <div className="footer">
//     <div className="footer-content">
//       <div className="footer-section contact">
//         <h2>Contact Us</h2>
//         <p>Have questions or need help? Reach out to us!</p>
//         <ul>
//           <li>Email: support@hrsaas.com</li>
//           <li>Phone: +123 456 7890</li>
//           <li>Address: 123 HR Street, Business City, ABC</li>
//         </ul>
//       </div>
//       <div className="footer-section links">
//         <h2>Quick Links</h2>
//         <ul>
//           <li>About Us</li>
//           <li>Pricing</li>
//           <li>Our Stories</li>
//           <li>Terms of Service</li>
//           <li>Privacy Policy</li>
//         </ul>
//       </div>
//     </div>
//     <div className="faq">
//       <h2>Frequently Asked Questions</h2>
//       <div className="faq-item">
//         <h3>What is HR SaaS?</h3>
//         <p>HR SaaS is an all-in-one solution for managing human resource operations such as hiring, payroll, and employee management.</p>
//       </div>
//       <div className="faq-item">
//         <h3>How secure is my data?</h3>
//         <p>Your data is protected with industry-standard encryption and security measures to ensure privacy and safety.</p>
//       </div>
//       <div className="faq-item">
//         <h3>Can I try before buying?</h3>
//         <p>Yes, you can start with our free demo to explore the platform before making any commitments.</p>
//       </div>
//     </div>
//     <div className="footer-bottom">
//       <p>&copy; 2024 HR SaaS. All Rights Reserved.</p>
//     </div>
//   </div>
  
//   );
// };



// export default Footer;
